import { render, staticRenderFns } from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=template&id=57551442&scoped=true&"
import script from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=style&index=0&id=57551442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57551442",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57551442')) {
      api.createRecord('57551442', component.options)
    } else {
      api.reload('57551442', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=template&id=57551442&scoped=true&", function () {
      api.rerender('57551442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionSettingStoperItemCheckpoint.vue"
export default component.exports